var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-5"},[_c('vendor-category',{staticClass:"bs-4"}),_c('state',{staticClass:"bs-5"})],1),_c('div',{staticClass:"col-md-6 mb-5"},[_c('country',{staticClass:"bs-5"}),_c('district',{staticClass:"bs-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }